import styled from "styled-components";

// 장바구니 공통 요소들
export const CartLengthCount = styled.h6`
  @media (max-width: 767px) {
    font-size: 13px !important;
    word-break: keep-all;
  }
`;

// web view Products 웹 사이즈 상품 목록
export const CartProductsWrapper = styled.div`
  & thead {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    & tr {
      border-bottom: 2px solid #ececec;
      & th {
        border: none;
        /* border-right: 1px solid #ececec; */
        :last-of-type {
          border: none;
        }
      }
    }
  }
  & tbody {
    text-align: center;

    & tr {
      border: none;
      border-bottom: 1px solid #ececec;
      & td {
        border: none;
      }
    }
  }

  & h6 {
    color: #696969;
  }

  & a {
    color: #696969;
    :hover {
      color: #3bb77e;
    }
  }

  .remove {
    font-size: 20px;
    & i {
      :hover {
        color: #dc3545;
      }
    }
  }

  .cart_init {
    & a {
      margin-left: auto;
      width: fit-content;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 14px;
      :hover {
        color: #3bb77e;
      }
      & i {
        margin-right: 5px;
      }
    }
  }

  @media (max-width: 991px) {
    display: none;
  }
`;

// mobile 모바일 사이즈 상품 목록
export const CartProductsMobile = styled.div`
  display: none;

  @media (max-width: 991px) {
    width: 100%;
    display: flex;
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ececec;
  }
`;

export const ProductMobileImg = styled.div`
  width: 20%;
  margin-right: 5%;
  min-width: 80px;

  & img {
    width: 100%;
    min-width: 80px;
  }
`;

export const ProductMobileInfo = styled.div`
  width: 75%;
  display: flex;
  flex-direction: column;
  cursor: pointer;

  & h6 {
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 5px;
    font-size: 20px;
    :hover {
      color: #3bb77e;
    }
  }
  & > span {
    margin-bottom: 10px;
    font-size: 16px;
  }
  & div {
    display: flex;
    align-items: center;
    justify-content: space-between;

    & span {
      font-size: 18px;
    }

    & h6 {
      margin-bottom: 0;
      font-size: 18px;
      border-right: 1px solid gray;
      padding-right: 10px;
    }

    & i {
      font-size: 16px;
      margin-left: 10px;
      margin-right: 10px;
      :nth-of-type(2) {
        margin-left: 10px;
      }
    }
  }

  @media (max-width: 575px) {
    & h6 {
      font-size: 18px;
    }
    & > span {
      font-size: 16px;
    }
    & div {
      & h6 {
        font-size: 16px;
      }
      & span {
        font-size: 16px;
      }
    }
  }
  @media (max-width: 424px) {
    & h6 {
      font-size: 16px;
    }
    & > span {
      font-size: 14px;
    }
    & div {
      & span {
        font-size: 14px;
        min-width: 22px;
      }
    }
  }
  @media (max-width: 360px) {
    & h6 {
      font-size: 14px;
    }
    & > span {
      font-size: 12px;
    }
    .fi-rs-trash {
      font-size: 12px;
    }
    & div {
      & h6 {
        font-size: 14px;
      }
      & i {
        margin: 3px;
        :nth-of-type(2) {
          margin-left: 3px;
        }
      }
      & span {
        font-size: 12px;
        min-width: 16px;
      }
    }
  }
`;

// 위시리스트
export const WishlistWrapper = styled.div`
  @media (max-width: 767px) {
    display: none;
  }
`;

export const WishlistInfo = styled.ul`
  width: 75%;
  & h6 {
    font-size: 18px;
  }
  & li {
    font-size: 16px;
    margin-bottom: 5px;
    color: #696969;
  }
  .action {
    display: flex;
    justify-content: flex-end;
  }

  & a {
    font-size: 24px;
    color: #696969;
    position: relative;
    transition: all 0.5s ease-out 0s;
    -webkit-transition: all 0.5s ease-out 0s;
    :hover {
      color: #3bb77e !important;
    }
  }
  .danger {
    /* background-color: #dc3545; */
    transition: 0.3s ease-in;
    :hover {
      /* background-color: #fdc040; */
      /* border-color: #fdc040; */
      color: #dc3545 !important;
      transition: 0.3s ease-in;
    }
  }
  @media (max-width: 575px) {
    & a {
      font-size: 20px;
    }
  }
`;

export const BtnInfo = styled.div`
  position: absolute;
  left: -150%;
  top: -200%;
  min-width: 100px;
  background-color: #fff;
  color: #121212;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  -webkit-transition: all 0.25s ease 0s;
  transition: all 0.25s ease 0s;
  border: 1px solid #ececec;
  border-radius: 5px;
  padding: 10px 10px;
  -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
  z-index: 999;
`;

export const BtnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .btns {
    width: 100%;
  }

  .basic_btns {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 10px;
    row-gap: 10px;
    margin-bottom: 10px;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    flex-direction: column;

    .btns {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      align-items: center;
      & a {
        margin: 0px;
      }
    }
  }

  @media screen and (max-width: 575px) {
    width: 100%;

    .basic_btns {
      grid-template-columns: repeat(2, 1fr);
    }
    & a {
      width: 100%;
    }
  }

  .btn {
    width: 100%;
    word-break: keep-all;
    border: 2px solid #3bb77e;
    :hover {
      background-color: #3bb77e;
      opacity: 0.8;
    }
  }

  .border_btn {
    background-color: #fff;
    color: #3bb77e;
    border: 2px solid #3bb77e;
    :hover {
      background-color: #fff;
      opacity: 0.8;
    }
  }

  .estimate {
    color: white;
    background-color: #fd7e14;
    border-color: #fd7e14;
    margin-bottom: 10px;
    :hover {
      background-color: #fd7e14;
      opacity: 0.8;
    }
  }

  .naver-btn {
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #00c13c;
    color: #fff;
    border-radius: 5px;
    font-size: 16px;
    border: 2px solid #00c13c;
    min-height: 50px;
    & img {
      max-width: 60px;
      margin-right: 10px;
    }
    transition: 0.3s ease;
    :hover {
      opacity: 0.8;
      transition: 0.3s ease;
    }
  }

  .naverpay_btn {
    display: none;
    @media screen and (max-width: 991px) {
      display: none;
    }
  }

  .naverpay_m_btn {
    display: none;
    @media screen and (max-width: 991px) {
      display: none;
    }
  }
`;

export const EmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 20vh;
  margin: 50px 0px;
  .title {
    margin-bottom: 30px;
  }
`;

export const CartSection = styled.section`
  background-color: #f7f5f6;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 50px 0px 50px;
  @media screen and (max-width: 767px) {
    padding: 50px 0px 0px;
  }
`;

export const CartHeader = styled.div`
  grid-column: 3 span / 3 span;
  width: 66.7%;
  display: flex;
  justify-content: space-between;
  padding: 0px 15px;
  font-size: 1rem;
  margin-bottom: 20px;
  & span {
    color: #828282;
  }
  .custome-checkbox {
    & span {
      color: #828282;
    }
  }
  .all-check {
    display: flex;
    align-items: center;
    & label {
      margin-bottom: 0px;
    }
  }
  .delete {
    display: flex;
    & span {
      cursor: pointer;
    }
  }

  @media screen and (max-width: 991px) {
    width: 100%;
  }
  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const CartBody = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 30px;

  .custome-checkbox {
    margin-right: 2px !important;
    & label {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  @media screen and (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 0px;
  }
`;

// 좌측 컨텐츠
export const CartMainWrapper = styled.div`
  grid-column: 2 span / 2 span;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

// 장바구니 상품리스트
export const CartListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
  @media screen and (max-width: 767px) {
    margin-bottom: 10px;
  }
`;

export const CartItem = styled.div`
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  background-color: #fff;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;

  .info {
    padding: 20px 15px 10px;
  }

  .delivery_price {
    border-top: 1px solid #e4e4e4;
    display: flex;
    justify-content: center;
    padding: 10px;
  }
`;

export const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .pname {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    & a {
      color: #253d4e;
    }
    .remove {
      color: #7e7e7e;
      :hover {
        color: orangered;
      }
    }
  }

  .deliveryInfo {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    word-break: keep-all;
    .divide {
      margin-right: 5px;
      margin-left: 5px;
    }
    @media screen and (max-width: 430px) {
      .divide {
        display: none;
      }
      & span {
        margin-right: 5px;
      }
    }
  }

  .direct {
    cursor: pointer;
    width: fit-content;
    text-decoration: none;
    position: relative;
    overflow: hidden;

    ::after {
      content: "";
      position: absolute;
      width: 0;
      left: 0%;
      bottom: 0;
      border-bottom: 1px solid #3bb77e;
      transition: width 0.2s, left 0.2s;
      -webkit-transition: width 0.2s, left 0.2s ease;
      visibility: hidden;
    }
    ::before {
      content: "";
      position: absolute;
      width: 0;
      left: 100%;
      bottom: 0;
      border-bottom: 1px solid #3bb77e;
      transition: width 0.2s, left 0.2s;
      -webkit-transition: width 0.2s, left 0.2s ease;
      visibility: visible;
    }

    :hover {
      color: #3bb77e;
      ::after {
        width: 100%;
        left: 0;
        visibility: visible;
      }
      ::before {
        width: 100%;
        left: 0;
        visibility: hidden;
      }
    }

    @media screen and (max-width: 991px) {
      font-size: 12px;
    }
  }
`;

export const ItemImg = styled.figure`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 72px;
  border-radius: 5px;
  overflow: hidden;
  margin-right: 10px;
`;

export const ItemPrice = styled.div`
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  padding: 10px 15px;
  color: #595959;
  margin-bottom: 5px;
  .option {
    margin-bottom: 15px;
    display: flex;
    flex-wrap: wrap;
    & span {
      margin-right: 5px;
      margin-left: 5px;
      :first-of-type {
        margin-left: 0px;
      }
      :last-of-type {
        margin-right: 0px;
      }
    }
  }

  .cntPrice {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .cnt {
    border-radius: 5px;
    border: 2px solid #e5e5e5;
    background: #fff;
    padding: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1rem;
    & i {
      cursor: pointer;
      :hover {
        color: #3bb77e;
      }
    }
    & span {
      margin-bottom: 3px;
    }
  }
`;

// 하단 추천 상품
export const RecommendedWrapper = styled.div`
  grid-column: 2 span / 2 span;
  background-color: #fff;
  padding: 20px 15px;
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  background-color: #fff;

  .title {
    margin-bottom: 20px;
  }
  @media screen and (max-width: 767px) {
    margin-bottom: 20px;
  }
`;

export const RecommendedSliderWrapper = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  .slider_nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 40%;
    left: -40px;
    width: calc(100% + 80px);

    & span {
      top: 25%;
      width: 50px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      box-shadow: 2px 3px 6px 0px rgba(105, 105, 105, 0.25);
      background-color: #fff;
      color: #5a5a5a;
      font-size: 19px;
      cursor: pointer;
      z-index: 9;
      :hover {
        background-color: #3bb77e;
        color: #fff;
      }
    }
    .custom_next_ct1 {
      right: 0;
    }
    @media screen and (max-width: 991px) {
      & span {
        width: 45px;
        height: 45px;
      }
    }
    @media screen and (max-width: 767px) {
      display: none;
    }
  }
`;

// 우측 sticky
export const CartSummaryWrapper = styled.div`
  grid-row: 2 span;
  display: block;
  position: relative;
  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const CartStickyWrapper = styled.div`
  position: sticky;
  top: 120px;
  transition: top 0.1s ease 0s;
  margin: 0;
  padding: 0;
`;

export const CartStickyInner = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  background-color: #fff;
  padding: 20px 15px;
  margin-bottom: 10px;

  & li {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    font-size: 1rem;
    color: #727272;
    :last-of-type {
      font-weight: 500;
      color: #000000;
      margin-bottom: 0px;
      margin-top: 30px;
    }
  }
  .info {
    line-height: 1.2;
    margin-top: 20px;
    font-size: 0.8rem;
    word-break: keep-all;
  }

  @media screen and (max-width: 767px) {
    & li {
      font-size: 14px;
      margin-bottom: 10px;
      :last-of-type {
        margin-top: 20px;
      }
    }
    .info {
      font-size: 12px;
    }
  }
`;

// 모바일 요약
export const MobileCartSummary = styled.div`
  display: none;

  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
  }
`;

// 모바일 바텀 버튼
export const MobileBtnSticky = styled.div`
  position: sticky;
  bottom: 0;
  display: none;
  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    z-index: 999;
    padding: 10px;
    background-color: hsla(0, 0%, 100%, 0.7);
    border-radius: 10px;
  }
`;
